
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("@embroider/util/ember-private-api", function(){ return i("@embroider/util/ember-private-api");});
d("@embroider/util/index", function(){ return i("@embroider/util/index");});
d("@embroider/util/services/ensure-registered", function(){ return i("@embroider/util/services/ensure-registered");});
import "@embroider/util/-embroider-implicit-modules.js";
